/* =========================================================
   DERMIQ — Premium animation runtime (v12)
   - Lenis smooth scroll
   - GSAP + ScrollTrigger
   - Magnetic buttons, custom cursor
   - Reveal-on-scroll, parallax, scroll-driven sections
   ========================================================= */

(function(){
  'use strict';

  var prefersReduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = matchMedia('(hover: none)').matches || ('ontouchstart' in window);

  function ready(fn){
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function whenReady(){
    var attempts = 0;
    return new Promise(function(resolve){
      (function poll(){
        if (window.gsap && window.ScrollTrigger) return resolve();
        if (attempts++ > 50) return resolve(); // bail after ~5s
        setTimeout(poll, 100);
      })();
    });
  }

  ready(function(){
    whenReady().then(init);
  });

  function init(){
    // ---------- LENIS SMOOTH SCROLL — DISABLED ----------
    // Native browser scroll is faster and feels less laggy on macOS.
    // GSAP/ScrollTrigger work fine on native scroll.

    if (window.gsap && window.ScrollTrigger){
      window.gsap.registerPlugin(window.ScrollTrigger);
    }

    // ---------- CUSTOM CURSOR — DISABLED ----------
    // Default OS cursor is restored. Remove any leftover DOM nodes
    // from earlier theme.liquid renders.
    var __cur = document.querySelector('.dq-cursor');
    var __dot = document.querySelector('.dq-cursor-dot');
    if (__cur) __cur.remove();
    if (__dot) __dot.remove();


    // ---------- REVEAL-ON-SCROLL (Intersection Observer fallback also works) ----------
    var revealEls = document.querySelectorAll('.dq-reveal, .dq-fade-up, .dq-img-reveal');
    if ('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if (en.isIntersecting){
            en.target.classList.add('is-in');
            io.unobserve(en.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      revealEls.forEach(function(el){ io.observe(el); });
    } else {
      revealEls.forEach(function(el){ el.classList.add('is-in'); });
    }

    // ---------- SCROLL PROGRESS ----------
    var prog = document.querySelector('.dq-progress-bar') || document.getElementById('dermiqProgress');
    if (prog){
      function tick(){
        var s = window.scrollY || document.documentElement.scrollTop;
        var h = document.documentElement.scrollHeight - window.innerHeight;
        var p = h > 0 ? Math.min(100, (s/h) * 100) : 0;
        prog.style.width = p + '%';
      }
      window.addEventListener('scroll', tick, { passive: true });
      tick();
    }

    // ---------- PARALLAX (data-parallax="0.3") ----------
    if (window.gsap && window.ScrollTrigger){
      document.querySelectorAll('[data-parallax]').forEach(function(el){
        var speed = parseFloat(el.getAttribute('data-parallax') || '0.2');
        window.gsap.to(el, {
          yPercent: -speed * 100,
          ease: 'none',
          scrollTrigger: {
            trigger: el,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1.2
          }
        });
      });
    }

    // ---------- INTRO OVERLAY DISMISS ----------
    var intro = document.querySelector('.dq-intro');
    if (intro){
      // Show only once per session
      try {
        if (sessionStorage.getItem('dqIntroShown')){
          intro.parentNode && intro.parentNode.removeChild(intro);
        } else {
          setTimeout(function(){
            intro.classList.add('is-out');
            sessionStorage.setItem('dqIntroShown', '1');
            setTimeout(function(){ intro.parentNode && intro.parentNode.removeChild(intro); }, 1400);
          }, 1700);
        }
      } catch(e){}
    }

    // ---------- VIEW TRANSITION SAME-ORIGIN LINKS — DISABLED ----------
    // This previously called e.preventDefault() on EVERY internal link and then
    // navigated itself via startViewTransition(). Inside Shopify's preview and
    // some browsers that self-navigation silently failed, which left every link
    // and button dead while still showing its hover underline. A cross-page fade
    // is not worth breaking navigation, so links now behave 100% natively.
    // (Intentionally left as a no-op.)
  }
})();
